export default __webpack_public_path__ + "static/media/750.792e736f.gif";